import RevenueOperation from '@/pages/dashboard/pages/realtime/revenue/components/RevenueOperation';
import { REALTIME_REVENUE_FILTER_KEY } from '@/pages/dashboard/_config/filters/realtime/index';
import { ComponentInfoType } from '@/pages/dashboard/types/dashboard';

// realtime revenue组件key值
export const REALTIME_REVENUE_COMPONENT_KEY = 'realtime_revenue';

// realtime revenue组件
export const realtimeRevenueComponentInfo: ComponentInfoType = {
  key: REALTIME_REVENUE_COMPONENT_KEY,
  filter: REALTIME_REVENUE_FILTER_KEY,
  Component: RevenueOperation
}

export default {
  [REALTIME_REVENUE_COMPONENT_KEY]: realtimeRevenueComponentInfo
}
